import { Feature, isAvailable } from 'App/services/FeatureHelperStandalone';
import AppService from 'App/legacy/AppService';

export default function InsightsAllowed() {
	if (AppService.getMetadata()?.params?.LookerDashboardExeptionIds) {
		return true;
	}
	return isAvailable(Feature.LOOKER);
}
